export function loadLocalStoreData<T = Record<string, unknown>>(
  name: string,
  defaultValue: null,
  serialization: true,
): T | null;
export function loadLocalStoreData<T>(name: string, defaultValue: T, serialization: true): T;
export function loadLocalStoreData<D extends string | null = null>(
  name: string,
  defaultValue?: D,
  serialization?: false,
): string | D;
export function loadLocalStoreData(
  name: string,
  defaultValue: unknown = null,
  serialization = false,
): unknown {
  try {
    const serializedData = localStorage.getItem(name);

    if (serializedData === null) {
      return defaultValue;
    }
    return serialization ? JSON.parse(serializedData) : serializedData;
  } catch (error) {
    return defaultValue;
  }
}

export const saveLocalStoreData = (key: string, data: unknown, serialization = false) => {
  try {
    const serializedData = serialization ? JSON.stringify(data) : String(data);

    localStorage.setItem(key, serializedData);
  } catch (error) {
    //eslint-disable-next-line
    console.log(error, "Privacy browser issue");
  }
};
